module.exports = __webpack_public_path__ + "static/img/12.1e0bfd46.png";